import React, { useEffect, useRef } from 'react';

// Lightweight parallax — uses CSS transforms on simple divs instead of canvas
const shapes = [
    { x: '10%', y: '15%', size: 6, speed: 0.3, color: 'rgba(214,255,62,0.12)' },
    { x: '85%', y: '30%', size: 4, speed: 0.2, color: 'rgba(214,255,62,0.08)' },
    { x: '50%', y: '50%', size: 8, speed: 0.1, color: 'rgba(102,126,234,0.06)' },
    { x: '20%', y: '70%', size: 5, speed: 0.15, color: 'rgba(102,126,234,0.08)' },
    { x: '75%', y: '80%', size: 10, speed: 0.05, color: 'rgba(214,255,62,0.04)' },
];

const ParallaxBackground = () => {
    const containerRef = useRef(null);
    const rafId = useRef(null);
    const lastScroll = useRef(0);

    useEffect(() => {
        const dots = containerRef.current?.querySelectorAll('.parallax-dot');
        if (!dots || dots.length === 0) return;

        const onScroll = () => {
            const scrollY = window.scrollY;
            if (Math.abs(scrollY - lastScroll.current) < 2) return; // Skip tiny changes
            lastScroll.current = scrollY;

            if (rafId.current) cancelAnimationFrame(rafId.current);
            rafId.current = requestAnimationFrame(() => {
                dots.forEach((dot, i) => {
                    const speed = shapes[i].speed;
                    dot.style.transform = `translateY(${-scrollY * speed}px)`;
                });
            });
        };

        window.addEventListener('scroll', onScroll, { passive: true });
        return () => {
            window.removeEventListener('scroll', onScroll);
            if (rafId.current) cancelAnimationFrame(rafId.current);
        };
    }, []);

    return (
        <div
            ref={containerRef}
            style={{
                position: 'fixed',
                inset: 0,
                pointerEvents: 'none',
                zIndex: 0,
                overflow: 'hidden',
            }}
        >
            {shapes.map((s, i) => (
                <div
                    key={i}
                    className="parallax-dot"
                    style={{
                        position: 'absolute',
                        left: s.x,
                        top: s.y,
                        width: s.size,
                        height: s.size,
                        borderRadius: '50%',
                        background: s.color,
                        willChange: 'transform',
                    }}
                />
            ))}
        </div>
    );
};

export default ParallaxBackground;
